var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.9746,
    r: 10,
    stroke: "#A94FE6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0704 12.7971L11.7064 17.161C11.3159 17.5516 10.6827 17.5516 10.2922 17.161L5.92825 12.7971C5.53773 12.4066 5.53773 11.7734 5.92825 11.3829C6.31878 10.9924 6.95194 10.9924 7.34247 11.3829L9.99932 14.0397V8.49414C9.99932 7.94186 10.447 7.49414 10.9993 7.49414V7.49414C11.5516 7.49414 11.9993 7.94186 11.9993 8.49414V14.0397L14.6562 11.3829C15.0467 10.9924 15.6799 10.9924 16.0704 11.3829C16.4609 11.7734 16.4609 12.4066 16.0704 12.7971Z",
    fill: "#A94FE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.bf0fbc433303189134bcd173de13e70d.svg";
export { ForwardRef as ReactComponent };